// extracted by mini-css-extract-plugin
export default {"safeArea":"safeArea__BrZ4B"};